import { LoadingIndicator, Button } from 'roo-ui/components';
import styled from '@emotion/styled';

export const OpaqueButton = styled(Button)`
  &:disabled {
    opacity: 1;
  }
`;

const ButtonWithLoadingIndicator = (props) => (
  <OpaqueButton {...props} bg="#870000" aria-label="Loading" aria-live="assertive">
    <LoadingIndicator color="white" size={21} />
  </OpaqueButton>
);

export default ButtonWithLoadingIndicator;
